import React, { useState } from 'react';
import { SaveIcon, RefreshCwIcon } from 'lucide-react';
import { DataSources } from './DataSources';
export const Settings: React.FC = () => {
  const [scanFrequency, setScanFrequency] = useState('daily');
  const [notificationSettings, setNotificationSettings] = useState({
    email: true,
    browser: false,
    slack: true
  });
  const [aiSettings, setAiSettings] = useState({
    autoClassify: true,
    autoGenerate: false,
    confidenceThreshold: 70
  });
  const [saving, setSaving] = useState(false);
  const handleSaveSettings = () => {
    setSaving(true);
    // Simulate saving settings
    setTimeout(() => {
      setSaving(false);
      alert('Settings saved successfully!');
    }, 1000);
  };
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-875">
      <div className="flex justify-between items-center mb-6" data-id="element-876">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-877">Settings</h1>
        <button onClick={handleSaveSettings} disabled={saving} className="inline-flex items-center px-4 py-2 bg-[#f9b30f] hover:bg-[#e0a40e] text-white text-sm font-medium rounded-md disabled:opacity-50" data-id="element-878">
          {saving ? <>
              <RefreshCwIcon size={16} className="mr-2 animate-spin" data-id="element-879" />
              Saving...
            </> : <>
              <SaveIcon size={16} className="mr-2" data-id="element-880" />
              Save Settings
            </>}
        </button>
      </div>
      <DataSources data-id="element-881" />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6" data-id="element-882">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-883">
          Monitoring Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-884">
          <div data-id="element-885">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-886">
              Scan Frequency
            </label>
            <select value={scanFrequency} onChange={e => setScanFrequency(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-887">
              <option value="hourly" data-id="element-888">Every hour</option>
              <option value="daily" data-id="element-889">Once a day</option>
              <option value="weekly" data-id="element-890">Once a week</option>
            </select>
            <p className="mt-1 text-sm text-gray-500" data-id="element-891">
              How often to scan for new intent signals
            </p>
          </div>
          <div data-id="element-892">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-893">
              Notification Preferences
            </label>
            <div className="space-y-2" data-id="element-894">
              <label className="flex items-center" data-id="element-895">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.email} onChange={e => setNotificationSettings({
                ...notificationSettings,
                email: e.target.checked
              })} data-id="element-896" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-897">
                  Email notifications
                </span>
              </label>
              <label className="flex items-center" data-id="element-898">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.browser} onChange={e => setNotificationSettings({
                ...notificationSettings,
                browser: e.target.checked
              })} data-id="element-899" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-900">
                  Browser notifications
                </span>
              </label>
              <label className="flex items-center" data-id="element-901">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.slack} onChange={e => setNotificationSettings({
                ...notificationSettings,
                slack: e.target.checked
              })} data-id="element-902" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-903">
                  Slack notifications
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6" data-id="element-904">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-905">
          AI Assistant Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-906">
          <div data-id="element-907">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-908">
              Automated Tasks
            </label>
            <div className="space-y-2" data-id="element-909">
              <label className="flex items-center" data-id="element-910">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={aiSettings.autoClassify} onChange={e => setAiSettings({
                ...aiSettings,
                autoClassify: e.target.checked
              })} data-id="element-911" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-912">
                  Automatically classify leads
                </span>
              </label>
              <label className="flex items-center" data-id="element-913">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={aiSettings.autoGenerate} onChange={e => setAiSettings({
                ...aiSettings,
                autoGenerate: e.target.checked
              })} data-id="element-914" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-915">
                  Auto-generate outreach messages
                </span>
              </label>
            </div>
          </div>
          <div data-id="element-916">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-917">
              AI Confidence Threshold ({aiSettings.confidenceThreshold}%)
            </label>
            <input type="range" min="50" max="90" value={aiSettings.confidenceThreshold} onChange={e => setAiSettings({
            ...aiSettings,
            confidenceThreshold: parseInt(e.target.value)
          })} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-918" />
            <p className="mt-1 text-sm text-gray-500" data-id="element-919">
              Minimum confidence level required for AI to take automated actions
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-920">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-921">
          Integration Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-922">
          <div data-id="element-923">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-924">
              CRM Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-925">
              <option value="" data-id="element-926">None</option>
              <option value="salesforce" data-id="element-927">Salesforce</option>
              <option value="hubspot" data-id="element-928">HubSpot</option>
              <option value="pipedrive" data-id="element-929">Pipedrive</option>
            </select>
          </div>
          <div data-id="element-930">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-931">
              Email Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-932">
              <option value="" data-id="element-933">None</option>
              <option value="gmail" data-id="element-934">Gmail</option>
              <option value="outlook" data-id="element-935">Outlook</option>
            </select>
          </div>
          <div data-id="element-936">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-937">
              Calendar Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-938">
              <option value="" data-id="element-939">None</option>
              <option value="gcal" data-id="element-940">Google Calendar</option>
              <option value="outlook" data-id="element-941">Outlook Calendar</option>
            </select>
          </div>
          <div data-id="element-942">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-943">
              Messaging Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-944">
              <option value="" data-id="element-945">None</option>
              <option value="slack" data-id="element-946">Slack</option>
              <option value="teams" data-id="element-947">Microsoft Teams</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
};